$(document).ready(function(){
  $(".accordion-list > li > h3").click(function(e){
    e.preventDefault();
    var o=$(this).closest("li"),t=o.find(".answer");
    o.hasClass("active")
      ? (o.removeClass("active"),t.slideUp())
      : ($(".accordion-list > li.active .answer").slideUp(),$(".accordion-list > li.active").removeClass("active"),o.addClass("active"),t.slideDown())
  })
});

document.addEventListener("DOMContentLoaded",()=>{
  let e=document.querySelector(".mobile-menu-text"),
      o=document.querySelector(".mobile-account-text"),
      t=document.querySelector(".mobile-menu-content"),
      i=document.querySelector(".mobile-login-content");
  if(!e||!o||!t||!i) return;
  function s(s){
    t.style.display=s?"block":"none";
    i.style.display=s?"none":"block";
    t.style.background="#d0f7ef";
    i.style.background="#d0f7ef";
    e.style.background=s?"#fff":"#baf3e8";
    o.style.background=s?"#baf3e8":"#fff"
  }
  e.addEventListener("click",()=>s(!0));
  o.addEventListener("click",()=>s(!1))
});

$(document).ready(function(){
  window.innerWidth<=769 && $(".collection-slider").slick({arrows:!1,dots:!0,infinite:!0,autoplay:!0,autoplaySpeed:3e3,slidesToShow:3,slidesToScroll:1,responsive:[{breakpoint:750,settings:{slidesToShow:2,slidesToScroll:1,arrows:!1,dots:!0}},{breakpoint:525,settings:{slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!0}}]});
  window.innerWidth<=999 && $(".blogpage-slider").slick({arrows:!1,dots:!0,infinite:!0,autoplay:!0,autoplaySpeed:3e3,slidesToShow:3,slidesToScroll:1,responsive:[{breakpoint:999,settings:{slidesToShow:3,slidesToScroll:1,arrows:!1,dots:!0}},{breakpoint:750,settings:{slidesToShow:2,slidesToScroll:1,arrows:!1,dots:!0}},{breakpoint:525,settings:{slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!0}}]})
});

setTimeout(function(){
  var el=document.querySelector(".jdgm-revs-tab__url");
  if(el) el.setAttribute("href","javascript:void()")
},5e3);

$(document).ready(function(){
  function e(){
    var e,o,t=(e=window.location.href,o=new URLSearchParams(window.location.search).get("limit"),console.log("URL:",e),console.log("Limit Value:",o),o);
    t&&$(document).find(".sortby-select option").each(function(){
      $(this).val()===t&&$(this).prop("selected",!0)
    })
  }
  $(document).on("change",".sortby-select",function(){setTimeout(e,1e3)})
});

if (window.innerWidth < 450) {
  let e=document.querySelector(".price-container .price-sale"),
      o=document.querySelector(".quna");
  e&&o&&(o.style.flexDirection="column-reverse",o.style.margin="0",o.style.gap="25px")
}

$(document).on("click","#HeaderMiniCart > div > form > div.mini-cart-header.drawer-header > drawer-toggle",function(){
  $("body").removeClass("header-mini-cart-open drawer-open");
  console.log("Button clicked!")
});

document.addEventListener("DOMContentLoaded",function(){
  var phoneEl=document.querySelector("a.phone-number.cst");
  if(!phoneEl) return;
  phoneEl.style.display="none";
  window.addEventListener("scroll",function(){
    phoneEl.style.display = window.scrollY>0 ? "block" : "none"
  })
});

if (window.innerWidth > 525) {
  function zoom(e) {
    var zoomer = e.currentTarget;
    if (zoomer.dataset && zoomer.dataset.zoomBg && !zoomer.style.backgroundImage) {
      zoomer.style.backgroundImage = "url(" + zoomer.dataset.zoomBg + ")";
    }
    var offsetX, offsetY, x, y;
    
    if (e.offsetX) {
      offsetX = e.offsetX;
      offsetY = e.offsetY;
    } else {
      offsetX = e.touches[0].pageX;
      offsetY = e.touches[0].pageY;
    }
    
    x = (offsetX / zoomer.offsetWidth) * 100;
    y = (offsetY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  document.querySelectorAll('.zoomable').forEach(function(el) {
    el.addEventListener('mousemove', zoom);
    el.addEventListener('touchmove', zoom);
  });
}

// Inject SKU into Globo filter product cards (collection, search pages & search suggestion overlay)
// Fallback only: written when Globo's card template was not rendering a SKU. The template
// now does (theme.liquid's #gspfProduct capture was fixed 2026-08-24), so each card is
// checked for an existing SKU block first - otherwise the number renders twice. Keeping
// the fallback means the SKU survives if Globo ever serves a template without it.
// The early return also skips one /products/{handle}.json request per card. 2026-08-25.
(function() {
  var skuCache = {};

  function fetchSku(handle, callback) {
    if (skuCache[handle] !== undefined) {
      callback(skuCache[handle]);
      return;
    }
    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var sku = data.product && data.product.variants[0] ? data.product.variants[0].sku : '';
        skuCache[handle] = sku;
        callback(sku);
      })
      .catch(function() {});
  }

  // Collection & search result page cards (.spf-product-card)
  function injectGloboCardSku() {
    document.querySelectorAll('.spf-product-card:not([data-sku-injected])').forEach(function(card) {
      if (card.querySelector('.list-sku-design')) {
        card.setAttribute('data-sku-injected', 'true');
        return;
      }
      var link = card.querySelector('.spf-product-card__title a');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!match) return;
      card.setAttribute('data-sku-injected', 'true');
      fetchSku(match[1], function(sku) {
        if (!sku || card.querySelector('.list-sku-design')) return;
        var priceWrapper = card.querySelector('.spf-product-card__price-wrapper');
        if (!priceWrapper) return;
        var el = document.createElement('div');
        el.className = 'list-sku-design spf-sku-display';
        el.innerHTML = '<p>SKU#: <span>' + sku + '</span></p>';
        priceWrapper.insertAdjacentElement('beforebegin', el);
      });
    });
  }

  // Search suggestion overlay cards (.gl-card)
  function injectSearchSuggestionSku() {
    document.querySelectorAll('.gl-card:not([data-sku-injected])').forEach(function(card) {
      if (card.querySelector('.gf-search-item-sku')) {
        card.setAttribute('data-sku-injected', 'true');
        return;
      }
      var link = card.querySelector('.gl-card-title a');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!match) return;
      card.setAttribute('data-sku-injected', 'true');
      fetchSku(match[1], function(sku) {
        if (!sku || card.querySelector('.gf-search-item-sku')) return;
        var pricing = card.querySelector('.gl-card-pricing');
        if (!pricing) return;
        var el = document.createElement('div');
        el.className = 'gf-search-item-sku gl-sku-display';
        el.textContent = 'SKU#: ' + sku;
        pricing.insertAdjacentElement('beforebegin', el);
      });
    });
  }

  window.addEventListener('globoFilterRenderCompleted', injectGloboCardSku);
  window.addEventListener('globoFilterRenderSearchCompleted', injectSearchSuggestionSku);
  document.addEventListener('DOMContentLoaded', function() { setTimeout(injectGloboCardSku, 800); });
})();

// 2026-09-18 optimisation: the product lightbox (product-modal) used to load a 4096px background + a 4096px <img> for
// every media on page load even though it is hidden (~10 MB on GIF-heavy products). The markup now carries the URLs in
// data-src / data-srcset / data-zoom-bg (snippets/product-gallery-media-modal.liquid) and this copies them into place
// the first time the lightbox is opened (or about to be opened). Covers slick clones too.
(function () {
  function hydrateProductModal(modal) {
    if (!modal || modal.dataset.adaiHydrated) return;
    modal.dataset.adaiHydrated = 'true';
    modal.querySelectorAll('img.adai-modal-lazy').forEach(function (img) {
      if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset.replace(/\s+/g, ' ').trim());
      if (img.dataset.src) img.setAttribute('src', img.dataset.src);
    });
    modal.querySelectorAll('figure.zoom[data-zoom-bg]').forEach(function (fig) {
      if (!fig.style.backgroundImage) fig.style.backgroundImage = 'url(' + fig.dataset.zoomBg + ')';
    });
  }
  function hydrateAll() { document.querySelectorAll('product-modal').forEach(hydrateProductModal); }
  document.addEventListener('product:modal-open', hydrateAll);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-modal-opener, .product-media-toggle, .product-media-icon-enlarge, .zoomable')) hydrateAll();
  }, true);
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      new MutationObserver(function () { if (modal.hasAttribute('open')) hydrateProductModal(modal); })
        .observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  });
})();



